import { SPI, FormFieldWidget, ViewType, ModelFieldType, FormM2OSelectFieldWidget, Widget } from '@kunlun/dependencies';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    model: ['file.ExcelExportTask', 'file.ExcelImportTask'],
    viewType: [ViewType.Form, ViewType.Search],
    ttype: ModelFieldType.ManyToOne
  })
)
// @ts-ignore
export class ExorptImportFormM2OSelectFieldWidget extends FormM2OSelectFieldWidget {
  initialize(props: any): this {
    super.initialize(props);
    return this;
  }

  @Widget.Reactive()
  private get needInitOptions() {
    return true;
  }

  protected async initLoadOptions() {
    await super.initLoadOptions();
    if (this.options?.length == 1) {
      this.change(this.options?.[0]);
    }
  }
}
